module.exports = __webpack_public_path__ + "static/media/appstore.65a13379.svg";